// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-jsx": function componentSrcPages404Jsx() {
    return import("./../../src/pages/404.jsx"
    /* webpackChunkName: "component---src-pages-404-jsx" */
    );
  },
  "component---src-pages-en-blog-index-jsx": function componentSrcPagesEnBlogIndexJsx() {
    return import("./../../src/pages/en/blog/index.jsx"
    /* webpackChunkName: "component---src-pages-en-blog-index-jsx" */
    );
  },
  "component---src-pages-index-jsx": function componentSrcPagesIndexJsx() {
    return import("./../../src/pages/index.jsx"
    /* webpackChunkName: "component---src-pages-index-jsx" */
    );
  },
  "component---src-pages-nl-blog-index-jsx": function componentSrcPagesNlBlogIndexJsx() {
    return import("./../../src/pages/nl/blog/index.jsx"
    /* webpackChunkName: "component---src-pages-nl-blog-index-jsx" */
    );
  },
  "component---src-pages-support-jsx": function componentSrcPagesSupportJsx() {
    return import("./../../src/pages/support.jsx"
    /* webpackChunkName: "component---src-pages-support-jsx" */
    );
  },
  "component---src-templates-blog-post-jsx": function componentSrcTemplatesBlogPostJsx() {
    return import("./../../src/templates/BlogPost.jsx"
    /* webpackChunkName: "component---src-templates-blog-post-jsx" */
    );
  },
  "component---src-templates-generic-page-jsx": function componentSrcTemplatesGenericPageJsx() {
    return import("./../../src/templates/GenericPage.jsx"
    /* webpackChunkName: "component---src-templates-generic-page-jsx" */
    );
  }
};